import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { menuCategories } from 'constants/menuCategories';
import DashboardCardComponent from './DashboardCardComponent';
import { useTranslation } from 'react-i18next';
import { useDashboardMenu } from 'hooks/useDashboardMenu';
import { Accordion, Typography } from '@totalsoft/rocket-ui';
import { useReactiveVar } from '@apollo/client';
import { dashboardSearchVar } from './variables';
import DashboardSearchComponent from './DashboardSearchComponent';

export const DashboardContainer = () => {
  const { t } = useTranslation();

  const { menuItems, loading: menuItemsloading } = useDashboardMenu();
  const search = useReactiveVar(dashboardSearchVar);

  const menus = useMemo(() => {
    if (!search) return menuItems;

    return menuItems.filter(
      menu =>
        t(menu.text).toLowerCase().indexOf(search.toLowerCase()) > -1 || t(menu.footer).toLowerCase().indexOf(search.toLowerCase()) > -1
    );
  }, [menuItems, search, t]);

  return (
    <Grid container spacing={1} justifyContent='center' alignItems='center'>
      {!menuItemsloading && (
        <>
          <DashboardSearchComponent />
          {Object.values(menuCategories)
            .filter(x => menus.find(y => y.category === x))
            .map(category => {
              return (
                <Grid item key={`card_${category}`} xs={12}>
                  <Accordion
                    defaultExpanded
                    title={
                      <Typography fontWeight='bold' variant='subtitle1'>
                        {t('Dashboard.Categories.' + category)}
                      </Typography>
                    }
                    sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}
                    content={
                      <Grid container spacing={2} justifyContent='flex-start' alignItems='stretch'>
                        {menus
                          .filter(x => x.category === category)
                          .map(menu => {
                            return <DashboardCardComponent menu={menu} key={menu.path}></DashboardCardComponent>;
                          })}
                      </Grid>
                    }
                  />
                </Grid>
              );
            })}
        </>
      )}
    </Grid>
  );
};

export default DashboardContainer;
